import React, { useState, useEffect, useCallback, useContext } from 'react';
import getCacheParams from '../../../modules/getCacheParams';

import LineChart from '../../Charts/LineChart';
import REQUEST from '../../../modules/REQUEST';
import BarChart from '../../Charts/BarChart';
import { Context } from '../../../Context';

const newChart = (name) => ({ title: name, categories: [], series: [] })

let interval

export default () => {

    const { setLoading } = useContext(Context)

    const [data, setData] = useState([])
    const [charts, setCharts] = useState({})

    useEffect(() => {
        // http://localhost:8084/evo_recebimentos?data_inicio=01.01.2023&data_fim=31.12.2023&data_inicio_p2=01.01.2023&data_fim_p2=31.12.2023&cliente=10&cr=18&tipoConsulta=3
        REQUEST.post('/rel/evo_recebimentos', getCacheParams())
            .then(resp => resp.data.filter(row => row.tipo_registro && row.tipo_registro !== 'P'))
            .then(setData)
            .then(() => setLoading(false))
            .catch(console.log)
    }, [])

    useEffect(() => {
        data.length && formatCharts()
    }, [data])

    const formatCharts = useCallback(() => {
        const newCharts = { totais: newChart('Totais'), registros: newChart('Registros dos meses somados') }
        data.forEach((obj, index) => {
            if (!index) {
                Object.keys(obj).forEach((key) => {
                    if (key.includes('saldo') && !key.includes('total')) {
                        let newCategorie = key.split('_')
                        newCategorie = newCategorie[1] + ' ' + newCategorie[2]
                        newCharts.totais.categories.push(newCategorie)
                    }
                })
            }
            if (['T', 'EV', 'FA'].includes(obj.tipo_registro)) {
                const newSerie = { name: obj.nome, data: [], type: obj.tipo_registro === 'T' ? 'line' : 'bar' }
                Object.keys(obj).forEach((key) => {
                    if (key.includes('saldo') && !key.includes('total')) {
                        newSerie.data.push(Math.round(obj[key] * 100) / 100)
                    }
                })
                newCharts.totais.series.push(newSerie)
            }
            else if (obj.tipo_registro === 'R') {
                if (!newCharts.registros.series.length) {
                    newCharts.registros.series.push({ data: [] })
                }
                newCharts.registros.categories.push(obj.nome.trim())
                newCharts.registros.series[0].data.push(Math.round(obj.saldo_total * 100) / 100)
            }
        })
        setCharts(newCharts)
    }, [data])

    const selectMonth = useCallback((event, props, config) => {
        const label = charts.totais.categories[config.dataPointIndex]
        const month = 'saldo_' + label.replace(' ', '_')
        if (interval) {
            clearInterval(interval)
            const newCharts = {}
            newCharts.totais = {
                title: charts.totais.title,
                categories: charts.totais.categories.filter((value, index) => index !== config.dataPointIndex),
                series: charts.totais.series.map(serie => ({ data: serie.data.filter((value, index) => index !== config.dataPointIndex) }))
            }
            if (charts.registros.title.includes('meses')) {
                newCharts.registros = {
                    title: 'Registros dos meses somados',
                    series: charts.registros.series.map(serie => ({
                        data: serie.data.map((value, index) => {
                            return value = value - Math.round(data.find(obj => obj.nome.trim() === charts.registros.categories[index])[month] * 100) / 100
                        })
                    })),
                    categories: charts.registros.categories,
                }
            }
            else if (charts.registros.title.includes(label)) {
                newCharts.registros = {
                    title: 'Registros dos meses somados',
                    series: [{
                        data: data.filter(obj => obj.tipo_registro === 'R').map(obj => Object.keys(obj).reduce((acc, key) => {
                            if (key.includes('saldo') && !key.includes('total') && newCharts.totais.categories.includes(key.slice(6).replace('_', ' '))) {
                                return acc + (Math.round(obj[key] * 100) / 100)
                            }
                            return acc
                        }, 0))
                    }],
                    categories: charts.registros.categories,
                }
            }
            setCharts({ ...charts, ...newCharts })
            interval = undefined
        }
        else {
            interval = setTimeout(() => {
                if (String(charts.registros.title).includes(charts.totais.categories[config.dataPointIndex])) {
                    const registros = {
                        title: 'Registros dos meses somados',
                        series: [{
                            data: data.filter(obj => obj.tipo_registro === 'R').map(obj => Object.keys(obj).reduce((acc, key) => {
                                if (key.includes('saldo') && !key.includes('total') && charts.totais.categories.includes(key.slice(6).replace('_', ' '))) {
                                    return acc + (Math.round(obj[key] * 100) / 100)
                                }
                                return acc
                            }, 0))
                        }],
                        categories: charts.registros.categories,
                    }
                    setCharts({ ...charts, registros })
                }
                else {
                    const registros = { title: 'Registro de ' + charts.totais.categories[config.dataPointIndex], categories: charts.registros.categories, series: [{ data: [] }] }
                    data.forEach(obj => {
                        if (obj.tipo_registro === 'R') {
                            registros.series[0].data.push(obj[month])
                        }
                    })
                    setCharts({ ...charts, registros })
                }
                interval = undefined
            }, 200);
        }
    }, [charts, data, setCharts])

    const customIconsTotais = [{
        icon: '<div class="apexcharts-reset-icon" title="Resetar Zoom"><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"></path><path d="M0 0h24v24H0z" fill="none"></path></svg></div>',
        click: formatCharts,
        index: 3,
        title: 'Restaurar',
        class: 'me-2'
    }]

    return (
        <div className="d-flex flex-wrap py-2">
            <div className="graph-cart px-3 py-2">
                <div className='shadow h-100 graph-cart-content'>
                    <LineChart categories={charts.totais?.categories} series={charts.totais?.series} title={charts.totais?.title} width='100%' height='100%' events={{ dataPointSelection: selectMonth }} customIcons={customIconsTotais} />
                </div>
            </div>
            <div className="graph-cart px-3 py-2">
                <div className='shadow h-100 graph-cart-content'>
                    <BarChart categories={charts.registros?.categories} series={charts.registros?.series} title={charts.registros?.title} width='100%' height='100%' />
                </div>
            </div>
        </div>
    )
}